import { createSlice, createAction } from '@reduxjs/toolkit';
import { removeFormikLocalStorageKeys } from 'utils/valueChecker';

export const initialState = {
  list: [],
  details: {},
  selectedRowID: null,
  forceRefresh: false,
  totalEntries: 0,
  dummyRowData: {},
};
// common to all slices
export const clearAllLists = createAction('SET_LIST_TO_EMPTY');

export const createSliceWithName = (name, initialState) =>
  createSlice({
    name,
    initialState,
    reducers: {
      fetchGridList: () => {
        // action only for saga
      },
      fetchGridRowDetails: () => {
        // action only for saga
      },
      fetchQr: () => {
        // action only for saga
      },
      fetchGridListPdf: () => {
        // action only for saga
      },
      fetchGridRowDetailsPdf: () => {
        // action only for saga
      },
      createRowEntry: () => {
        // action only for saga
      },
      updateRowEntry: () => {
        // action only for saga
      },
      setGridList: (state, { payload }) => {
        const { list, totalEntries } = payload;
        state.list = list;
        state.totalEntries = totalEntries;
      },
      setGridRowDetails: (state, { payload }) => {
        state.details = payload.details;
        state.dummyRowData = payload?.dummyRowData ? payload.dummyRowData : {};
      },
      setForceRefresh: (state, { payload }) => {
        state.forceRefresh = payload;
      },
      setSelectedRowID: (state, { payload }) => {
        state.selectedRowID = payload;
      },
    },
    extraReducers: {
      // list of actions from another slice that has affect in site redux state
      // 'actionType':(state, ations) => {}
      TOGGLE_MODAL: () => {
        removeFormikLocalStorageKeys();
      },
      SET_LIST_TO_EMPTY: state => {
        state.list = [];
        state.totalEntries = [];
      },
    },
  });
